import { render, staticRenderFns } from "./iblLinks.vue?vue&type=template&id=5d958b12"
import script from "./iblLinks.vue?vue&type=script&lang=js"
export * from "./iblLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports